import angular from "angular"

export default angular.module("notificationModule", [
    "ngStorage",
    "remoteModule"
])